import { render, staticRenderFns } from "./EditProfileModal.vue?vue&type=template&id=1e42b52d&scoped=true&"
import script from "./EditProfileModal.vue?vue&type=script&lang=js&"
export * from "./EditProfileModal.vue?vue&type=script&lang=js&"
import style0 from "./EditProfileModal.vue?vue&type=style&index=0&id=1e42b52d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e42b52d",
  null
  
)

export default component.exports